<div class="dropdown custom-dropdown">
  <button
    type="button"
    class="btn btn-{{ color }} btn-{{ size }}"
    data-bs-toggle="dropdown"
  >
    <i class="{{ icon }}"></i> {{ placeholder }}
    <i class="fa fa-angle-down ms-3"></i>
  </button>

  <div
    class="dropdown-menu {{ align }}"
    [style.max-height]="maxHeight"
    style="overflow: auto"
  >
    <ng-container *ngIf="!grouped; else groupedContent">
      <div
        *ngFor="let item of options"
        class="dropdown-item"
        style="cursor: pointer"
        [class.active]="item[optionLabel] === active"
        [class.disabled]="item[optionLabel] === disabled"
        (click)="itemClicked(item)" role="button"  tabindex="-1"
      >
        {{ item[optionLabel] }}
      </div>
    </ng-container>

    <ng-template #groupedContent>
      <ng-container *ngFor="let group of options">
        <h5 class="dropdown-header {{ groupHeaderStyle }} ">
          {{ group[groupHeader] }}
        </h5>
        <div
          *ngFor="let item of group[groupList]"
          class="dropdown-item"
          style="cursor: pointer"
          (click)="itemClicked(item)" role="button"  tabindex="-1"
        >
          {{ item[optionLabel] }}
        </div>
      </ng-container>
    </ng-template>

    <div class="dropdown-item">
      <ng-content select="[extraItem]"></ng-content>
    </div>
  </div>
</div>
